import { render } from "./Modal.vue?vue&type=template&id=d48f83e8&scoped=true&style=display%3A%20flex%3B%20justify-content%3A%20center%3B%20align-items%3A%20center%3B"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=d48f83e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48f83e8"]])

export default __exports__